import React from 'react'

const ProjectTeamGovernanceHome: React.FC = () => (
  <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="70" height="70" rx="14.5455" fill="url(#paint0_linear_984_19461)" />
    <path
      d="M48.0118 24.4482C50.7142 24.4482 52.8936 26.5841 52.85 29.2429C52.85 31.8582 50.5835 34.0812 47.9682 34.0812C45.3529 34.0812 43.1299 31.8582 43.1299 29.2429C43.1735 26.4969 45.2657 24.4482 48.0118 24.4482Z"
      fill="white"
    />
    <path
      d="M21.9461 24.4482C24.6485 24.4482 26.828 26.5841 26.7844 29.2429C26.7844 31.8582 24.5178 34.0812 21.9025 34.0812C19.2872 34.0812 17.0642 31.8582 17.0642 29.2429C17.0642 26.4969 19.2 24.4482 21.9461 24.4482Z"
      fill="white"
    />
    <path
      d="M56.8601 42.7989C55.8575 38.658 51.9346 35.7812 47.5758 35.9555C46.3553 35.9991 45.1784 36.3042 44.1323 36.8273C45.7887 38.658 47.0091 40.9682 47.5758 43.5834C47.7066 44.1501 47.7501 44.6296 47.7937 45.0654C47.8809 45.0654 47.9245 45.0654 48.0117 45.0654C50.409 45.0654 52.7628 45.0654 55.1601 45.0654C56.8601 45.0654 57.2524 44.4988 56.8601 42.7989Z"
      fill="white"
    />
    <path
      d="M22.382 44.4553C22.8614 41.5349 24.1255 38.9196 25.9126 36.8709C24.5614 36.2171 23.0794 35.8684 21.5102 35.9556C17.3693 36.0864 13.7951 39.2683 13.0541 43.3656C12.8361 44.4989 13.272 45.0219 14.4489 45.0219C16.9334 45.0219 19.4615 45.0219 21.9461 45.0219C22.0768 45.0219 22.2076 45.0219 22.3384 45.0219C22.3384 44.8476 22.3384 44.6732 22.382 44.4553Z"
      fill="white"
    />
    <path
      d="M35.0226 45.1964C32.1894 45.1964 29.3997 45.1964 26.5665 45.1964C25.2153 45.1964 24.7358 44.5862 24.9538 43.3221C25.7819 38.6582 29.8356 35.084 34.4996 34.9532C39.4686 34.7788 43.871 38.0479 45.0043 42.7119C45.4838 44.6298 45.0043 45.24 43.0428 45.24C40.384 45.1964 37.6815 45.1964 35.0226 45.1964Z"
      fill="white"
    />
    <path
      d="M35.0659 21.7458C38.1171 21.7458 40.558 24.1432 40.558 27.1508C40.558 30.0712 37.9863 32.5993 35.0223 32.5993C32.0583 32.5993 29.5738 30.0712 29.5738 27.1072C29.5302 24.0996 31.9712 21.7458 35.0659 21.7458Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_984_19461"
        x1="34.5455"
        y1="2.70945e-07"
        x2="34.5455"
        y2="70"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#07888D" />
        <stop offset="1" stopColor="#006064" />
      </linearGradient>
    </defs>
  </svg>
)

export default ProjectTeamGovernanceHome
